import type { Socket } from "socket.io-client";

export interface MenuRef {
	current?: { setDetail(detail: unknown[]): void };
}

export interface ClientSession {
	id: string;
	ts: number;
	state: Record<string, unknown>;
	slug: string;
	socket: Socket | undefined;
	playerId: string | null | undefined;
	mountPoint: string | null;
	rootPoint?: string | null;
	cleanup: Array<() => void>;
	onEnd?: () => void;
	menuRef?: MenuRef;
}

const sessionData = new Map<string, ClientSession>();

export { sessionData };
export default sessionData;
